import axios from "../../config/interceptor";

export const getGTMConfigByBusinessId = async (businesId) => {
  try {
    let link =
      `/lambda/v1/business/gtm-config/${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
